import * as ReactDOM from "react-dom"
import App from "./app"

import "./stylesheets/base.scss"

ReactDOM.render(<App />, document.getElementById("root"))
